module.exports = __webpack_public_path__ + "static/media/68.623f6996.jpg";